import { render } from "./DataBlend.vue?vue&type=template&id=6c8c24b9"
import script from "./DataBlend.vue?vue&type=script&lang=js"
export * from "./DataBlend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/DataBlend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c8c24b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c8c24b9', __exports__)) {
    api.reload('6c8c24b9', __exports__)
  }
  
  module.hot.accept("./DataBlend.vue?vue&type=template&id=6c8c24b9", () => {
    api.rerender('6c8c24b9', render)
  })

}


export default __exports__